export default 'M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24m0 21.5A9.5 9.5 0 0 1 2.5 12h19a9.5 9.5 0 0 1-9.5 9.5';